import request from '@/utils/request'

// 车辆调试报告分页列表
export function ebikeDebugReportList(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/list',
    method: 'get',
    params: data,
  })
}

// 删除车辆调试报告
export function ebikeDebugReportdDelete(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/delete',
    method: 'post',
    data,
  })
}

// 车辆调试报告查看详情
export function ebikeDebugReportDetail(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/detail',
    method: 'get',
    params: data,
  })
}

// 新增 车辆调试报告
export function ebikeDebugReportAdd(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/add',
    method: 'post',
    data,
  })
}

// 导出 车辆调试报告
export function ebikeDebugReportExport(data) {
  return request({
    url: '/system/api/admin/export/ebikeDebugReport',
    method: 'get',
    params: data,
  })
}

// 车辆列表分页
export function findEbikePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findEbikePage',
    method: 'post',
    data,
  })
}

// 根据IOT查询车辆详情
export function findEbikeDetail(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findEbikeDetail',
    method: 'post',
    data,
  })
}

// 根据整车编号查询车辆详情
export function findEbikeDetail1(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeCertificateConformity/findEbikeDetail',
    method: 'get',
    params: data,
  })
}

// 车型绑定
export function bindModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/bindModel',
    method: 'post',
    data,
  })
}

// 车辆解绑
export function cancelBindEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/cancelBindEbike',
    method: 'post',
    data,
  })
}

// 查询车型分页
export function findEbikeModelPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/findEbikeModelPage',
    method: 'post',
    data,
  })
}

// 新增车型
export function saveEbikeModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/saveEbikeModel',
    method: 'post',
    data,
  })
}

// 修改车型
export function updateEbikeModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/updateEbikeModel',
    method: 'post',
    data,
  })
}

// 删除车型
export function deleteEbikeModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/deleteEbikeModel',
    method: 'post',
    data,
  })
}

// 车型详情
export function findEbikeModelDetail(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/findEbikeModelDetail',
    method: 'post',
    data,
  })
}

// 查询故障分页
export function findFaultPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/fault/findFaultPage',
    method: 'post',
    data,
  })
}

// 查看历史报警信息
export function getEbikePosture(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/getEbikePosture',
    method: 'post',
    data,
  })
}

// 运输模式
export function sendTransportInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/sendTransportInfo',
    method: 'post',
    data,
  })
}

// 分配运营商
export function tenantBindEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/tenantBindEbike',
    method: 'post',
    data,
  })
}

// 导入五通码
export function importEbikeVin(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importEbikeVin',
    method: 'post',
    data,
  })
}

// 批量导入分配归属
export function importTenantBindEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importTenantBindEbike',
    method: 'post',
    data,
  })
}

// 导入IOT
export function importEbikeIdMacNoTenantId(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importEbikeIdMacNoTenantId',
    method: 'post',
    data,
  })
}

// 固件信息列表分页
export function findUpgradePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/findUpgradePage',
    method: 'post',
    data,
  })
}

// OTA管理列表分页
export function findOtaFirmwarePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/findOtaFirmwarePage',
    method: 'post',
    data,
  })
}

// OTA新增
export function saveFirmwareInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/saveFirmwareInfo',
    method: 'post',
    data,
  })
}

// OTA编辑
export function modifyFirmwareInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/modifyFirmwareInfo',
    method: 'post',
    data,
  })
}

// OTA删除
export function removeFirmwareInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/removeFirmwareInfo',
    method: 'post',
    data,
  })
}

// 骑行分页
export function findCyclePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/cycle/findCyclePage',
    method: 'post',
    data,
  })
}

// 车辆轨迹列表
export function findCycleTraceList(data) {
  return request({
    url: '/ebike/listek-ebike/web/cycle/findCycleTraceList',
    method: 'post',
    data,
  })
}

// 修改车辆基本信息
export function modifyEbikeBaseInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/modifyEbikeBaseInfo',
    method: 'post',
    data,
  })
}

// 车型解绑
export function cancelBindModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/cancelBindModel',
    method: 'post',
    data,
  })
}

// IOT列表
export function findOnlineIotPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findOnlineIotPage',
    method: 'post',
    data,
  })
}

// 厂商-商户
export function otaFirmwareInfoList1() {
  return request({
    url: '/system/api/admin/otaFirmwareInfo/list1',
    method: 'get',
  })
}

// 类型
export function otaFirmwareInfoList2(data) {
  return request({
    url: '/system/api/admin/otaFirmwareInfo/list2',
    method: 'get',
    params: data,
  })
}

// 版本号
export function otaFirmwareInfoList3(data) {
  return request({
    url: '/system/api/admin/otaFirmwareInfo/list3',
    method: 'get',
    params: data,
  })
}

// 版本配置
export function sendUpgradeInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ota/sendUpgradeInfo',
    method: 'post',
    data,
  })
}

// 车辆列表IOT按钮
export function findIotStatusInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findIotStatusInfo',
    method: 'post',
    data,
  })
}

// IOT订阅的主题
export function findIotSubscribeTopic(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findIotSubscribeTopic',
    method: 'post',
    data,
  })
}

// IOT命令日志
export function findIotCmdLog(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findIotCmdLog',
    method: 'post',
    data,
  })
}

// 路书列表
export function findTravelPlanPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/travelPlan/findTravelPlanPage',
    method: 'post',
    data,
  })
}

// 路书删除
export function removeTravelPlan(data) {
  return request({
    url: '/ebike/listek-ebike/web/travelPlan/removeTravelPlan',
    method: 'post',
    data,
  })
}

// 路书保存
export function saveTravelPlan(data) {
  return request({
    url: '/ebike/listek-ebike/web/travelPlan/saveTravelPlan',
    method: 'post',
    data,
  })
}

// 路书修改
export function modifyTravelPlan(data) {
  return request({
    url: '/ebike/listek-ebike/web/travelPlan/modifyTravelPlan',
    method: 'post',
    data,
  })
}

// 导出车辆
export function exportEbike(data) {
  return request({
    url: '/system/api/admin/export/ebike',
    method: 'post',
    data,
  })
}

// 删除IOT车辆
export function removeIotEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/removeIotEbike',
    method: 'post',
    data,
  })
}

// 通过租户id获取车辆id
export function listEbikeIdByTenantId(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/listEbikeIdByTenantId',
    method: 'get',
    params: data,
  })
}

// 折线图-温度
export function lineCharTemp(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/lineCharTemp',
    method: 'get',
    params: data,
  })
}

// 折线图-电流电压
export function lineChartBatteryVoltageCurrent(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/lineChartBatteryVoltageCurrent',
    method: 'get',
    params: data,
  })
}

// 折线图-速度功率百分比
export function lineChartSpeedPowerPercent(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/lineChartSpeedPowerPercent',
    method: 'get',
    params: data,
  })
}

// 变量-下拉选择
export function listFields() {
  return request({
    url: '/system/api/admin/ebikeDebugReport/listFields',
    method: 'get',
  })
}

// 变量-折线图
export function lineChartFields(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/lineChartFields',
    method: 'get',
    params: data,
  })
}

// 骑行轨迹图
export function lngLatAlt(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/lngLatAlt',
    method: 'get',
    params: data,
  })
}

// 报表-统计大数
export function statistics(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/statistics',
    method: 'get',
    params: data,
  })
}

// 添加车辆
export function addEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/addEbike',
    method: 'post',
    params: data,
  })
}

// 批量导入车辆信息
export function importEbikeBaseInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importEbikeBaseInfo',
    method: 'post',
    data,
  })
}

// 批量导入合格证
export function importCertificate(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeCertificateConformity/import',
    method: 'post',
    data,
  })
}

// 合格证分页
export function ebikeCertificateConformity(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeCertificateConformity/findPage',
    method: 'post',
    data,
  })
}

// 合格证详情
export function selecteById(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeCertificateConformity/selecteById',
    method: 'get',
    params: data,
  })
}

// 车型汇总
export function findEbikeSummaryModelPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findEbikeModelPage',
    method: 'post',
    data,
  })
}

// 导出车型
export function exportEbikeModel(data) {
  return request({
    url: '/system/api/admin/export/ebikeModel',
    method: 'get',
    params: data,
  })
}

// 根据厂商id查询车型下拉列表
export function queryIotEbikeModelList(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/queryIotEbikeModelList',
    method: 'get',
    params: data,
  })
}

// 批量升级分页
export function findEbikeBatchUpgradePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findEbikeBatchUpgradePage',
    method: 'post',
    data,
  })
}

// 批量导入车辆出厂信息
export function importEbikeModelCertificateConformity(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importEbikeModelCertificateConformity',
    method: 'post',
    data,
  })
}

// 批量修改车辆出厂信息
export function importEditEbikeInfo(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/importEditEbikeInfo',
    method: 'post',
    data,
  })
}

// 根据objectName获取文件
export function downloadTempFile(data) {
  return request({
    url: '/ebike/listek-ebike/web/file/downloadTempFile',
    method: 'get',
    params: data,
  })
}

// 根据整车编号查询维修记录
export function queryWebMaintainRecordListByEbikeCode(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/queryWebMaintainRecordListByEbikeCode',
    method: 'get',
    params: data,
  })
}

// 根据整车编号查询销售记录
export function querySaleListByEbikeCode(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/querySaleListByEbikeCode',
    method: 'get',
    params: data,
  })
}

// 根据IOT编号查询维修记录
export function queryWebMaintainRecordListByEbikeId(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/queryWebMaintainRecordListByEbikeId',
    method: 'get',
    params: data,
  })
}

// 批量导入车型
export function importEbikeModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebikeModel/importEbikeModel',
    method: 'post',
    data,
  })
}

// 导出CCC
export function fullEbikeCcc(data) {
  return request({
    url: '/system/api/admin/export/fullEbikeCcc',
    method: 'post',
    data,
  })
}

// 导出整车
export function fullEbikeFactory(data) {
  return request({
    url: '/system/api/admin/export/fullEbikeFactory',
    method: 'post',
    data,
  })
}

// 偏移值
export function editIotEbikeModel(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/editIotEbikeModel',
    method: 'post',
    data,
  })
}

// 获取单个电池电压接口
export function ebikeDBatteryVoltageList(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/getEbikeDBatteryVoltageList',
    method: 'get',
    params: data,
  })
}

// 获取车辆运行数据源列表
export function getEbikeDebugReportList(data) {
  return request({
    url: '/system/api/admin/ebikeDebugReport/getDebugReportDataSource',
    method: 'get',
    params: data,
  })
}
